module.exports = __webpack_public_path__ + "img/hero-background.fd1d0ff2.png";